import React, { Fragment } from 'react';

import { PageTitle } from '../../../layout-components';
import TeamsDashboard from '../../../flowtrace-components/MeetingStatistics/Teams';

const explanation = []
explanation.push(<h4 key="header" className="heading-2 pb-1">Team by Team breakdown of Meetings</h4>)
explanation.push(<p key="paragraph1">This view is designed to show employee centric (aggregated to teams) view of the meetings.</p>)
explanation.push(<p key="paragraph2">Here the data is broken down by attending and organizing teams, and showing their behavior in the meetings.</p>)
explanation.push(<p key="paragraph3">Team filtering narrows down to the teams we show as participation, not by who has organized the meeting.</p>)

export default function TeamsMeetingDashboard(props) {
  return (
    <Fragment>
      <PageTitle key="title" titleHeading="Meetings by Team Participation" titleDescription="Visualize the way teams participate in your meetings" explanation={explanation}/>

      <TeamsDashboard flowtraceUser={ props.flowtraceUser }/>
    </Fragment>
  );
}
